import useKeyboardInteractions from 'src/hooks/useKeyboardInteractions';
import useResolution from 'src/hooks/useResolution';
import useUI from 'src/hooks/useUI';
import { UserEventTriggerType } from 'src/interfaces/Datahub';
import SettingOption from 'src/themes/cosmos/components/SettingOption';
import { CheckIcon } from 'src/themes/cosmos/icons';

const ResolutionControlContainer = () => {
  const { hideSettings } = useUI();
  const { playlist, setResolution, resolution: resolutionSelected } = useResolution();

  const { registerItem } = useKeyboardInteractions();

  return (
    <>
      {playlist.map((resolution, index) => {
        const isActive = resolution.label === resolutionSelected.label;
        return (
          <SettingOption
            {...registerItem({ index, startWithFocus: isActive })}
            key={resolution.label}
            aria-label={resolution.label}
            active={isActive}
            rightIcon={isActive && <CheckIcon data-testid='check-icon' />}
            onClick={() => {
              hideSettings();
              setResolution(resolution, UserEventTriggerType.CLICK);
            }}
          >
            {resolution.label}
          </SettingOption>
        );
      })}
    </>
  );
};

export default ResolutionControlContainer;
